class TechniquesAutoComplete extends HTMLElement {
	constructor() {
		super();
	}
	searchFor(input) {
		return DojoDeshi.instance().RPC().TechniqueSearch(this.classRecordId, input).then(
			([searchTerm, techniques, err])=>{
				if (err) {
					throw(err);
				}
				console.log(`searchFor returned `, [searchTerm, techniques, err]);
				let res = [searchTerm];		
				for (let t of techniques) {
					res.push(t.Name);
				}
				return res;
			});
	}
	get classRecordId() {
		return parseInt(this.getAttribute(`data-record-id`));
	}
}

customElements.define(`dojo-techniques-auto-complete`, TechniquesAutoComplete);